import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from "@/store";
import { Tool } from "@/util/tool";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/Login.vue')
  },
  {
    path: '/',
    redirect: "/Home",
    meta: {
      isLogin: true
    }
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home/Home.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/EditRecord/:record',
    name: 'EditRecord',
    component: () => import('../views/EditRecord/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/EnrollRecord/:TrainingStage/:SubjectCode/:AudienceCode',
    name: 'EnrollRecord',
    component: () => import('../views/EnrollRecord/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/PaidResult/:record',
    name: 'PaidResult',
    component: () => import('../views/PaidResult/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/Records',
    name: 'Records',
    component: () => import('../views/Records/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/PayRecords',
    name: 'PayRecords',
    component: () => import('../views/PayRecords/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/Periods',
    name: 'Periods',
    component: () => import('../views/Periods/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/Invoice',
    name: 'Invoice',
    component: () => import('../views/Invoice/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/OtherPayRecords',
    name: 'OtherPayRecords',
    component: () => import('../views/OtherPayRecords/Index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/OtherInvoice',
    name: 'OtherInvoice',
    component: () => import('../views/OtherInvoice/Index.vue'),
    meta: {
      isLogin: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(item => {
    // console.log(item, '是否需要登录校验:', item.meta.isLogin)
    return item.meta.isLogin
  })) {
    const loginUser = store.state.user
    if (Tool.isEmpty(loginUser)) {
      // console.log('用户未登录')
      next('/login')
    } else {
      next()
    }
  } else {
    const loginUser = store.state.user
    if (!Tool.isEmpty(loginUser)) {
      next('/')
    } else {
      next()
    }
  }
})

export default router
